import Md5 from 'blueimp-md5'
// import { FILES_PRIVATE, FILES_PUBLIC } from 'mp-stjk-configs/config'
// import { Profile } from 'mp-stjk-provider'
import LibContext from 'config/Context';

class ImageService {
  getPublicImageUrl(imageUrl, size) {
    if (!imageUrl) {
      return null;
    }
    return `${LibContext.getInstance().settings.FILES_PUBLIC}${imageUrl}`;
  }

  getPrivateUrl(tfsKey, imageSize) {
    // todo 从外围注入
    const tk = encodeURIComponent(LibContext.getInstance().tk);
    if (!tfsKey) {
      throw new Error("参数tfsKey未设置");
    }
    let tfsKeyWithSize = tfsKey;
    return `${LibContext.getInstance().settings.FILES_PRIVATE}${tfsKeyWithSize}?_tk=${tk}`;
  }

  getVideoUrl(tfsKey) {
    const tk = encodeURIComponent(LibContext.getInstance().tk);
    const ts = new Date().getTime(),
      sign = Md5(tfsKey + ts).toLowerCase();
    return `${LibContext.getInstance().settings.FILES_PRIVATE}/v2/video/${tfsKey}.mp4?_tk=${tk}&ts=${ts}&sign=${sign}`;
  }

  strToHexCharCode(str) {
    if (str === "") {
      return "";
    }
    const hexCharCode = [];
    hexCharCode.push("0x");
    for (let i = 0; i < str.length; i++) {
      hexCharCode.push(str.charCodeAt(i).toString(16));
    }
    return hexCharCode.join("");
  }
}
export default new ImageService()
